import React, { PropsWithChildren } from "react";

import { Loading } from "./Loading";

export const Loadable: React.FC<PropsWithChildren<{ isLoading: boolean }>> = ({
  isLoading,
  children,
}) => {
  if (isLoading) return <Loading />;
  return <>{children}</>;
};
